export const klaviyoPopupTiming = {
    key: "klaviyo-popup-timing",
    formId: "Xyn6M9",
    init: (value) => {

        try{
            switch(value){
                case "immediate":
                    klaviyoPopupTiming.showForm();
                    break;
                case "2nd-pageview": {
                    let pageviews = JSON.parse(sessionStorage.getItem("klaviyoPagesVisitCount"));

                    if(Array.isArray(pageviews) && pageviews.length > 1){
                        klaviyoPopupTiming.showForm();
                    }

                    break;
                }
                case "10sec":
                    console.log("klaviyo popup timing default");
                    window.setTimeout(() => {
                        klaviyoPopupTiming.showForm();
                    }, 10000)
                    break;
            }
        }catch(e){
            console.error("klaviyoPopupTiming test error", e);
        }
    },
    showForm: () => {
        const klaviyoOnsite = JSON.parse(localStorage.getItem("klaviyoOnsite"));
        const disabledForms = klaviyoOnsite?.viewedForms?.modal?.disabledForms;
        if(!Object.prototype.hasOwnProperty.call(disabledForms, klaviyoPopupTiming.formId)){
            console.log("klaviyoPopupTiming showForm");
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', klaviyoPopupTiming.formId]);
        }else{
            console.log("klaviyoPopupTiming showForm disabled");
        }
    }
}